import React, { useState, useEffect } from 'react';
import PanelSidebar from './PanelSidebar';
import PanelTopbar from './PanelTopbar';

const PanelLayout = ({ role = 'user', title, breadcrumb, actions, hideTopbar, noPad, children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Load cached user immediately so sidebar renders fast
    try {
      const raw = localStorage.getItem('user');
      if (raw) setUser(JSON.parse(raw));
    } catch {}

    // Then fetch fresh data from /user/me to pick up disabled_tabs changes
    if (role === 'user') {
      const token = localStorage.getItem('token');
      if (!token) return;
      const base = process.env.REACT_APP_API_URL || 'https://api.a1xpay.com/api';
      fetch(`${base}/user/me`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      })
        .then(r => r.json())
        .then(data => {
          if (data?.success && data.user) {
            setUser(data.user);
            localStorage.setItem('user', JSON.stringify(data.user));
          }
        })
        .catch(() => {});
    }
  }, [role]);

  // Persist collapsed state
  useEffect(() => {
    const saved = localStorage.getItem('pn-sidebar-collapsed');
    if (saved === '1') setCollapsed(true);
  }, []);
  const toggleCollapsed = () => {
    setCollapsed((c) => {
      const next = !c;
      localStorage.setItem('pn-sidebar-collapsed', next ? '1' : '0');
      return next;
    });
  };

  return (
    <div className="panel-layout-wrapper">
      <div className={`panel-shell ${collapsed ? 'is-collapsed' : ''} ${mobileOpen ? 'is-mobile-open' : ''}`}>
        <div className="panel-mobile-overlay" onClick={() => setMobileOpen(false)} />

        <PanelSidebar
          role={role}
          user={user}
          collapsed={collapsed}
          toggleCollapsed={toggleCollapsed}
          mobileOpen={mobileOpen}
          closeMobile={() => setMobileOpen(false)}
        />

        <div className="panel-main">
          {!hideTopbar && (
            <PanelTopbar
              title={title}
              breadcrumb={breadcrumb}
              actions={actions}
              user={user}
              role={role}
              onMobileToggle={() => setMobileOpen((m) => !m)}
            />
          )}
          <main className="panel-content" style={noPad ? { padding: 0 } : {}}>
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default PanelLayout;
